@use '@/sass/variables';

.search-filter {
  .search-bar {
    margin-bottom: 0;
    padding-right: variables.$spacing-extra-large;
    padding-left: variables.$spacing-large;
    max-width: none;
    width: 100%;
  }
  .reset-search {
    position: absolute;
    right: variables.$spacing-medium;
    top: 12px;
    z-index: 1;
  }
  .search-icon {
    position: absolute;
    z-index: 1;
    left: variables.$spacing-small;
    top: 11px;
    color: variables.$dark-gray;
  }
  .scroll-container {
    min-height: 224px;
  }
}
